export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apl",
  "May",
  "June",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const years = [2025, 2024, 2023, 2022, 2021, 2020];
